import { onClose, onError, onMessage, onOpen } from "./websocket-events.ts";
import { AppStore } from "../store/store.ts";
import { selectLoan, selectSession } from "../store/selectors/select.slice.ts";
import { SocketMessageDtoV2EventTypeEnum } from "../orchestrator-api-client";
import { clearQueue } from "../store/slices/session/session.slice.ts";
import { AppRoutes } from "../enums/app-routes.ts";
import {
  DirectChannels,
  ExternalComparatorsChannels,
} from "../enums/channels.ts";

export const buildWSUrl = (host: string) => {
  const url = new URL(`${host}/web-socket?`);

  return (wfId: string) => {
    url.searchParams.set("wfid", wfId);
    return url;
  };
};

export const buildRandomizedWSUrl = (ws_endpoint: string, wfId: string) =>
  buildWSUrl(ws_endpoint)(wfId);

export const produceWebsocket = (store: AppStore, ws_endpoint: string) => {
  const state = store.getState();
  const { token } = selectSession(state);
  const { workflowId } = selectLoan(state);

  if (typeof token === "undefined") {
    return;
  }

  if (!workflowId) {
    return;
  }

  const randomizedWsUrl: string = buildRandomizedWSUrl(
    ws_endpoint,
    workflowId,
  ).toString();
  const ws = new WebSocket(randomizedWsUrl);

  ws.addEventListener("open", onOpen(store));
  ws.addEventListener("error", onError(store));
  ws.addEventListener("message", onMessage(store, ws));
  ws.addEventListener("close", onClose(store));

  return ws;
};

export const sendWsMetricsEvents = (
  store: AppStore,
  ws: WebSocket | undefined,
) => {
  const state = store.getState();
  const { wsEventsQueue } = selectSession(state);
  const { channel } = selectLoan(state);

  if (!wsEventsQueue.length) {
    return;
  }
  if (typeof ws === "undefined") {
    return;
  }

  if (ws.readyState === WebSocket.OPEN) {
    wsEventsQueue.forEach((wsEvent) => {
      ws.send(
        JSON.stringify({
          eventType: SocketMessageDtoV2EventTypeEnum.Metric,
          payload: {
            metric: {
              name: "PageViewCount",
              value: 1,
              unit: "COUNT",
              dimensions: {
                pageName: wsEvent.toUpperCase(),
                channel:
                  wsEvent.toUpperCase() === AppRoutes.WELCOME
                    ? ExternalComparatorsChannels.POL_WEB
                    : channel || DirectChannels.DIRECT,
              },
            },
          },
        }),
      );
    });
    store.dispatch(clearQueue([]));
  }
};
